export default __webpack_public_path__ + "static/media/profile-user.e8ff08ea.svg";